import { parseQuery } from './mini/parseQuery';
const GaService = {
    setUserId: (userId) => {
        if (window.ga) {
            window.ga('set', 'dimension1', userId);
            window.ga('set', 'userId', userId);
        }
    },

    sendSignUpPageView: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': '/Virtual/GetStartedButton/' });
        }
    },

    sendContactUsPageView: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': '/Virtual/ContactSalesButton/' });
        }
    },

    sendSignedUpPageView: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': '/Virtual/SuccessfulSignUp/' });
        }
    },

    sendFirstProjectCreatedPageView: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': '/Virtual/FirstProjectCreated/' });
        }
    },

    sendSignInEvent: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': 'Virtual/Sign_In_btn_Click' });
            sendCampaignInfo('Sign_In_btn_Click', 'Email');
        }
    },

    sendSignInWGoogleEvent: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': 'Virtual/Sign_In_with_Google_btn_Click' });
            sendCampaignInfo('Sign_In_with_Google_btn_Click', 'Google');
        }
    },

    sendSignInWGitHubEvent: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': 'Virtual/Sign_In_with_GitHub_btn_Click' });
            sendCampaignInfo('Sign_In_with_GitHub_btn_Click', 'GitHub');
        }
    },

    sendSignUpEvent: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': 'Virtual/Sign_Up_btn_Click' });
            sendCampaignInfo('Sign_Up_btn_Click', 'Email');
        }
    },

    sendSignUpWGoogleEvent: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': 'Virtual/Sign_Up_with_Google_btn_Click' });
            sendCampaignInfo('Sign_Up_with_Google_btn_Click', 'Google');
        }
    },

    sendSignUpWGitHubEvent: () => {
        if (window.ga) {
            window.ga('send', { 'hitType': 'pageview', 'page': 'Virtual/Sign_Up_with_GitHub_btn_Click' });
            sendCampaignInfo('Sign_Up_with_GitHub_btn_Click', 'GitHub');
        }
    },

    sendFirstLoginEvent: ({ campaignName, loginType }) => {
        if (window.ga) {
            window.ga('send', {
                hitType: 'event',
                eventCategory: 'Registration',
                eventAction: 'First_Login',
                eventLabel: `Campaign: ${campaignName || 'none'}; LoginType: ${loginType}`
            });
        }
    },
    sendPaymentEvent: ({
        amount,
        promoCode,
        paymentType,
        campaignName
    }) => {
        if (window.ga) {
            window.ga('send', {
                hitType: 'event',
                eventCategory: 'Payments',
                eventAction: 'Payment',
                eventLabel: `Campaign: ${campaignName || 'none'}; PaymentType: ${paymentType};${amount ? ` Amount: ${amount}` : ''}${promoCode ? ` PromoCode: ${promoCode}` : ''}`
            });
        }
    },
};

function sendCampaignInfo(action, authType) {
    const campaignName = parseQuery(localStorage.getItem('params'))['utm_campaign'];

    if (window.ga) {
        if (campaignName) {
            window.ga('send', { 'hitType': 'pageview', 'page': `Virtual/${campaignName}/${action}/${authType}` });
        }
        window.ga('send', {
            hitType: 'event',
            eventCategory: 'Registration',
            eventAction: action,
            eventLabel: `Campaign: ${campaignName || 'none'}; LoginType: ${authType}`
        });
    }
}

export default GaService;